import { Position, GameMap } from '../types/GameMap';
import { SimNPC } from '../types/SimNPC';

/**
 * 2点間の距離（マンハッタン距離）
 */
export function getManhattanDistance(pos1: Position, pos2: Position): number {
  return Math.abs(pos1.x - pos2.x) + Math.abs(pos1.y - pos2.y);
}

/**
 * 移動可能か判定
 */
export function isValidMove(pos: Position, map: GameMap): boolean {
  const { width, height, tiles } = map;

  // 範囲チェック
  if (pos.x < 0 || pos.x >= width || pos.y < 0 || pos.y >= height) {
    return false;
  }

  // 移動不可タイルチェック
  const tile = tiles[pos.y][pos.x];
  return tile.type !== 'mountain';
}

/**
 * 位置を更新
 */
export function updateNPCPosition(
  npc: SimNPC,
  newPos: Position,
  map: GameMap
): void {
  const oldTile = map.tiles[npc.position.y][npc.position.x];
  const newTile = map.tiles[newPos.y][newPos.x];

  // 古いタイルから削除
  const oldIndex = oldTile.npcs.indexOf(npc.id);
  if (oldIndex >= 0) {
    oldTile.npcs.splice(oldIndex, 1);
  }

  // 新しいタイルに追加
  if (!newTile.npcs.includes(npc.id)) {
    newTile.npcs.push(npc.id);
  }

  // NPC位置更新
  npc.position = newPos;
}

/**
 * マップ上にNPCを初期配置
 */
export function placeNPCOnMap(npc: SimNPC, map: GameMap): void {
  const tile = map.tiles[npc.position.y][npc.position.x];
  if (!tile.npcs.includes(npc.id)) {
    tile.npcs.push(npc.id);
  }
}
